import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CampaignEditor from "@/pages/CampaignEditor";
import CampaignDetail from "@/pages/CampaignDetail";
import Landing from "@/pages/Landing";
import Watch from "@/pages/Watch";
import AdminLayout from "@/components/AdminLayout";
import ReportPage from "@/pages/ReportPage";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Reader from "@/pages/Reader";
import ProgramEditor from "@/pages/ProgramEditor";
import ProgramDetail from "@/pages/ProgramDetail";
import Hub from "@/pages/Hub";
import Content from "@/pages/Content";
import Reports from "@/pages/Reports";
import ClientReport from "@/pages/ClientReport";
import ShortLink from "@/pages/ShortLink";

const Protected = ({ children, noLayout = false }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen bg-[#0B0F17] grid place-items-center text-slate-400 font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return noLayout ? children : <AdminLayout>{children}</AdminLayout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admin/campaigns/new" element={<Protected><CampaignEditor /></Protected>} />
          <Route path="/admin/campaigns/:id/edit" element={<Protected><CampaignEditor /></Protected>} />
          <Route path="/admin/campaigns/:id" element={<Protected><CampaignDetail /></Protected>} />
          <Route path="/admin/campaigns/:id/reports/:leadId" element={<Protected noLayout><ReportPage /></Protected>} />
          <Route path="/admin/programs/new" element={<Protected><ProgramEditor /></Protected>} />
          <Route path="/admin/programs/:id/edit" element={<Protected><ProgramEditor /></Protected>} />
          <Route path="/admin/programs/:id" element={<Protected><ProgramDetail /></Protected>} />
          <Route path="/admin/content" element={<Protected><Content /></Protected>} />
          <Route path="/admin/reports" element={<Protected><Reports /></Protected>} />
          <Route path="/h/:hubSlug" element={<Hub />} />
          <Route path="/r/:token" element={<ClientReport />} />
          <Route path="/s/:code" element={<ShortLink />} />
          <Route path="/admin/team" element={<Protected><Team /></Protected>} />
          <Route path="/admin/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/c/:slug" element={<Landing />} />
          <Route path="/c/:slug/watch" element={<Watch />} />
          <Route path="/c/:slug/read" element={<Reader />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </AuthProvider>
  );
}

export default App;
